import React from 'react';
export default function TextMediaAccordionItemTitle(props) {
    var item = props.item, i = props.i, itemIndex = props.itemIndex, displayAsInline = props.displayAsInline;
    var TitleTag = ((displayAsInline ? 'div' : 'button') || 'div');
    var color1 = item.fields.color1 || "#BE81FE";
    var color2 = item.fields.color2 || "#E63205";
    return (React.createElement(React.Fragment, { key: i },
        item.fields && item.fields.displayTitle &&
            React.createElement(TitleTag, { className: "title border-0 bg-transparent font1 text-start ps-0 " + item.fields.titleStyle
                    + " text-color-" + item.fields.titleColor, itemProp: "name" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: item.fields.displayTitle } }),
                React.createElement("span", { className: "filed-icon" + ((item.fields.color1 == "none" || item.fields.color2 == "none") ? " d-none" : ""), style: {
                        zIndex: 5,
                        borderRadius: "50%",
                        display: "block",
                        position: "absolute",
                        top: "3px",
                        right: "0px",
                        width: "27px",
                        height: "27px",
                        backgroundColor: color1,
                        backgroundImage: "radial-gradient(at 0% 0%, ".concat(color2, " -50px, transparent 50%), radial-gradient(at 0% 36%, ").concat(color2, " -50px, transparent 50%), radial-gradient(at 0% 60%, ").concat(color2, " -50px, transparent 50%), radial-gradient(at 0% 70%, ").concat(color2, " -50px, transparent 50%),radial-gradient(at 0% 90%, ").concat(color2, " 0px, transparent 44%),radial-gradient(at 100% 100%, ").concat(color2, " -36px, transparent 27%)"),
                    } })),
        item.fields.icon &&
            React.createElement("img", { src: item.fields.icon, alt: item.fields.icon_description ? item.fields.icon_description : "FlyOver", className: "flyout-accordion-icon " + "icon-color-" + item.fields.iconColour }) || null));
}
